import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Button, Tabs } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import OffersTable from './OffersTable';
import { useCompanyDeals } from '../../../hooks/useDeals';

const Offers = ({ 
  setCurrentDeal, 
  page, 
  setIsModalOpen,
  isLoading: parentLoading,
  error: parentError 
}) => {
  const [status, setStatus] = useState('active');
  
  // React Query pour récupérer les offres selon le statut
  const { 
    data: deals, 
    isLoading, 
    error,
    refetch 
  } = useCompanyDeals(page?._id, status === 'past');

  // Utiliser les états du parent ou du hook local
  const finalLoading = parentLoading || isLoading;
  const finalError = parentError || error;

  const items = [
    {
      key: 'active',
      label: 'Offres actives',
      children: (
        <OffersTable 
          datas={deals?.deals || []} 
          setCurrentDeal={setCurrentDeal}
          setIsModalOpen={setIsModalOpen}
          isLoading={finalLoading}
          error={finalError}
          onRefresh={refetch}
        />
      ),
    },
    {
      key: 'past',
      label: 'Offres passées',
      children: (
        <OffersTable 
          datas={deals?.deals || []} 
          setCurrentDeal={setCurrentDeal}
          setIsModalOpen={setIsModalOpen}
          isLoading={finalLoading}
          error={finalError}
          onRefresh={refetch}
        />
      ),
    },
  ];

  return (
    <div className='h-full m-4 md:w-full flex flex-col gap-6'>
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200">
          Mes offres
        </h2>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setIsModalOpen(); // Appeler sans paramètre pour créer une nouvelle offre
          }}
          size="large"
        >
          Créer une offre
        </Button>
      </div>

      <Tabs 
        activeKey={status} 
        onChange={setStatus} 
        items={items}
        className="flex-1"
      />
    </div>
  );
};

export default Offers;